import React from 'react';
import fetch from '../../core/fetch';

class LoginPZ extends React.Component {

  componentDidMount() {
     if (!props.wkLogin) {
      window.location.replace(`${window.location.origin}${process.env.LOGIN_ENDPOINT}?redirectUrl=${window.location.href}`);
    }
  }

  render() {
    return <div>Wczytywanie...</div>;
  }
}


export default LoginPZ;



// WEBPACK FOOTER //
// src/routes/eservices/loginPZ.js